import { render, staticRenderFns } from "./categoryForm.vue?vue&type=template&id=56a2e6a1&scoped=true&"
import script from "./categoryForm.vue?vue&type=script&lang=js&"
export * from "./categoryForm.vue?vue&type=script&lang=js&"
import style0 from "./categoryForm.vue?vue&type=style&index=0&id=56a2e6a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2e6a1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56a2e6a1')) {
      api.createRecord('56a2e6a1', component.options)
    } else {
      api.reload('56a2e6a1', component.options)
    }
    module.hot.accept("./categoryForm.vue?vue&type=template&id=56a2e6a1&scoped=true&", function () {
      api.rerender('56a2e6a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/home/components/categoryForm.vue"
export default component.exports